// extracted by mini-css-extract-plugin
export default {"fs":"ea9c71a013 b3e9b89f99"};